'use client';

import type * as React from 'react';
import { useSearchBoxBase_unstable } from '@fluentui/react-search';

import type { SearchBoxProps, SearchBoxState } from './Search.types';
import { toDataAttributeValue } from '../../utils';

/**
 * Returns the state for a SearchBox component, given its props and ref.
 * The returned state can be modified with hooks before being passed to `renderSearchBox`.
 */
export const useSearchBox = (props: SearchBoxProps, ref: React.Ref<HTMLInputElement>): SearchBoxState => {
  const state: SearchBoxState = useSearchBoxBase_unstable(props, ref);

  // Set data attributes for disabled and focused states to simplify styling of these states.
  // eslint-disable-next-line react-hooks/immutability
  state.root['data-disabled'] = toDataAttributeValue(state.disabled);
  // eslint-disable-next-line react-hooks/immutability
  state.root['data-focused'] = toDataAttributeValue(state.focused);

  return state;
};
